<template>
  <v-list color="primary" width="100%">
    <template v-for="item in items">
      <v-list-item v-if="item.btn" :key="item.btn.i">
        <v-list-item-icon class="mr-2">
          <v-icon dense right class="mx-0 px-0" color="white">{{
            item.icon
          }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title v-for="btn in item.btn" :key="btn.i">
            <v-btn
              class="white--text font-weight-bold text-caption"
              text
              :href="btn.href"
              v-text="btn.title"
            >
            </v-btn>
          </v-list-item-title>
          <v-list-item-subtitle
            v-text="item.subtitle"
            class="ml-4 mt-n2 white--text font-weight-light text-caption"
          >
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item v-else :key="item.i">
        <v-list-item-icon class="mr-2">
          <v-icon dense right class="mx-0 px-0" color="white">{{
            item.icon
          }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title
            v-text="item.title"
            class="ml-4 white--text font-weight-bold text-overline"
          />
          <v-list-item-subtitle
            v-text="item.subtitle"
            class="ml-4 white--text font-weight-light text-caption"
          />
        </v-list-item-content>
      </v-list-item>
    </template>
  </v-list>
</template>

<script>
export default {
  data: () => ({
    items: [
      {
        btn: [
          {
            title: "(011)-5370-0873 ",
            href: "tel:+5491153700873 "
          }
        ],
        subtitle: "Teléfono de línea",
        icon: "mdi-phone-classic"
      },
      {
        btn: [
          {
            title: "(011)-3100-8698 ",
            href: "tel:+5491131008698 "
          },
          {
            title: "(011)-3142-6844 ",
            href: "tel:+5491131426844 "
          },
          {
            title: "(011)-2579-5329 ",
            href: "tel:+5491125795329 "
          }
        ],
        subtitle: "",
        icon: "mdi-cellphone-iphone"
      },
      {
        btn: [
          {
            title: "info@argecam.com.ar",
            href: "mailto:info@argecam.com.ar"
          }
        ],
        subtitle: "Envianos tu consulta",
        icon: "mdi-email"
      },
      {
        btn: [
          {
            title: "whatsapp",
            href: "https://wa.me/5491131008698"
          }
        ],
        subtitle: "Chateá con nosotros!",
        icon: "mdi-whatsapp"
      },
      {
        btn: [
          {
            title: "Ventana 3562 - CABA - CP: 1437",
            href: "https://goo.gl/maps/52K7h527cTxWi8A39"
          }
        ],
        subtitle: "Oficina",
        icon: "mdi-map-marker"
      },
      {
        title: "Horarios",
        subtitle: "Lun a Vier 09 a 17 horas.",
        icon: "mdi-calendar"
      }
    ]
  })
};
</script>
